export default __webpack_public_path__ + "static/brokers-image-4-a55695b8af71316e2c9beada470fc416.png";